import { LazyAction, LazyModule } from 'owa-bundling';
export { default as isWebPushNotificationSupported } from './utils/isWebPushNotificationSupported';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailWebPushNotifications" */ './lazyIndex')
);

// Used in bootstrap of different modules
export const lazyCheckSupportAndBootstrapWebPushService = new LazyAction(
    lazyModule,
    m => m.checkSupportAndBootstrapWebPushService
);

// Used for getting notifications preference for current browser from SDS (persistent storage).
export const lazyGetUserNotificationsPreferenceForCurrentBrowser = new LazyAction(
    lazyModule,
    m => m.getUserNotificationsPreferenceForCurrentBrowser
);

// Used for fetching push notifications subscription for current client as stored in OWA push server
export const lazyGetOwaPushSubscriptionForCurrentClient = new LazyAction(
    lazyModule,
    m => m.getOwaPushSubscriptionForCurrentClient
);

// Used for enabling notifications in notification settings
export const lazyUserInitiatedWebPushSetupWorkflow = new LazyAction(
    lazyModule,
    m => m.userInitiatedWebPushSetupWorkflow
);

// used for disabling notifications on current client or on all clients in notification settings
export const lazyUserInitiatedWebPushDisableWorkflow = new LazyAction(
    lazyModule,
    m => m.userInitiatedWebPushDisableWorkflow
);

// Used to check whether onboarding is to be shown or not
export const lazyCanShowWebPushOnboarding = new LazyAction(
    lazyModule,
    m => m.canShowWebPushOnboarding
);

// Used to update user preference in SDS
export const lazyUpdateUserPreference = new LazyAction(lazyModule, m => m.updateUserPreference);

// Used to update partial properties of user preference in SDS
export const lazyUpdatePartialUserPreference = new LazyAction(
    lazyModule,
    m => m.updatePartialUserPreference
);

// Used to increment the browser impression count of push notification onboarding campaign in SDS
export const lazyIncrementPushNotificationsOnboardingCount = new LazyAction(
    lazyModule,
    m => m.incrementPushNotificationsOnboardingCount
);
